<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-积分管理-积分明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input v-model="formInline.search" placeholder="用户ID"></el-input>
        </el-form-item>
        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.value1" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="rel_val.order_no" label="订单号"></el-table-column>
          <el-table-column prop="nickName" label="微信头像" width="70">
            <template slot-scope="scope">
              <img v-if="scope.row.rel_val.user" :src="scope.row.rel_val.user.avatarUrl" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="" label="昵称">
            <template slot-scope="scope">
              <span>{{(scope.row.rel_val.user?scope.row.rel_val.user.nickName:'')}}</span>
              <span class="gray9">(用户ID：{{scope.row.rel_val.user?scope.row.rel_val.user.user_id:""}})</span>
            </template>
          </el-table-column>
          <el-table-column prop="rel_val.pay_price" label="付费金额"></el-table-column>
          <el-table-column prop="rel_val.grade_id" label="升级等级">
            <template slot-scope="scope">
              <span>{{scope.row.rel_val.grade?scope.row.rel_val.grade.name:""}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rel_val.order_text" label="审核状态"></el-table-column>
          <el-table-column prop="rel_val.pay_text" label="付款方式"></el-table-column>
          <el-table-column prop="rel_val.state_text" label="付款状态"></el-table-column>
          
          <el-table-column prop="rel_val.create_time" label="创建时间"></el-table-column>
           <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope">
              <div>
                <el-button v-if="scope.row.status == 0"  @click="editClick(scope.row.rel_val)" type="text" size="small">
                  审核
                </el-button>
                <!-- <el-button  @click="makeClick(scope.row.rel_val)" type="text" size="small">
                  生成
                </el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
   <Edit v-if="open_edit" :open_edit="open_edit" :form="orderModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
   <Make v-if="open_make" :open_make="open_make" :form="orderModel" @closeDialog="closeDialogFunc($event, 'make')"></Make>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  import Edit from './Edit.vue';
  import Make from './Make.vue';
  export default {
    components: {
      Edit,
      Make
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          search: '',
          value1: ''
        },
        /*当前编辑的对象*/
        orderModel: {},
         /*是否打开编辑弹窗*/
         open_edit: false,
         open_make:false,
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        UserApi.gradeOrderList(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        }).catch(error => {

        });
      },
    /*打开弹出层编辑*/
    editClick(item) {
      this.orderModel = item;
      this.open_edit = true;
    },
    /*打开弹出层生成证书*/
    makeClick(item) {
      console.log(this.open_make);
      this.orderModel = item;
      this.open_make = true;
    },

     /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'make') {
        this.open_make = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getTableList();
      },
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/setting/part/Log.vue